import * as React from 'react';
import { useEffect } from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Fab from '@mui/material/Fab';

import DehazeIcon from '@mui/icons-material/Dehaze';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import FlatwareIcon from '@mui/icons-material/Flatware';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import CreateIcon from '@mui/icons-material/Create';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import * as util from "../../utils/util";
import api from "../../utils/api";

const counsel = {
  id: '',
  title: '',
  content: '',
  createDate: '',
  answer: '',
  type: '',
  category: '',
  answerDate: '',
  memberId: ''
}

const Counsel = () => {

  const navigate = useNavigate();
  const [alignment, setAlignment] = React.useState('all');
  const [expandedAccordions, setExpandedAccordions] = React.useState([10000000]);
  const [counselList, setCounselList] = React.useState([counsel]);
  const [counselType, setCounselType] = React.useState('ALL');

  useEffect(() => {
    if (util.strNull(window.localStorage.userCusID) !== '') {
      getCounselList('ALL', '');
    }
  }, []);

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  const accordionClicked = (index: any) => {
    if (expandedAccordions.includes(index))
      setExpandedAccordions(
        expandedAccordions.filter((number) => number !== index)
      );
    else setExpandedAccordions([...expandedAccordions, index]);
  };

  const collapseAll = () => {
    setExpandedAccordions([]);
  };

  function getCounselList(type: any, category: any) {
    collapseAll();  // 아코디언 모두 접기
    setCounselType(type); // [전체상담, 내 상담] 탭 구분
    if (counselType !== type) {  // [전체상담, 내 상담] 탭 변경 시, 하위 카테고리 [전체] 초기화
      setAlignment('all');
    }
    api.get(`app/api/v1/AP_003_001?type=${type}&category=${category}`).then(res => {
      setCounselList(res.data.result_data.support_list);
    }).catch(function (error) {
      console.log(error)
    });
  }

  function getCategoryChipComponent(category: any) {
    if (category === 'EXERCISE') {
      return <Chip icon={<FitnessCenterIcon />} label="운동" color="primary" size="small" />;
    } else if (category === 'HEALTH') {
      return <Chip icon={<HealthAndSafetyIcon />} label="건강" color="secondary" size="small" />;
    } else if (category === 'DIET') {
      return <Chip icon={<FlatwareIcon />} label="식이" color="info" size="small" />;
    }
  }



  return (
    <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', pt: 12, pb: 12, minWidth: 320 }}>
      <Top title='상담' />

      <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 1, bgcolor: '#ffb068', borderRadius: '20px' }}>
        <CareButton variant="contained" sx={counselType === 'ALL' ? {} : { bgcolor: '#FFB068', color: '#fff' }}
          onClick={() => {
            getCounselList('ALL', '')
          }}
        >
          전체상담
        </CareButton>
        <CareButton variant="contained" sx={counselType === 'MY' ? {} : { bgcolor: '#FFB068', color: '#fff' }}
          onClick={() => {
            getCounselList('MY', '')
          }}
        >
          내 상담
        </CareButton>
      </Stack>

      <Stack direction="row" spacing={0} sx={{ mt: 3 }}>
        <ToggleButtonGroup
          value={alignment}
          exclusive
          onChange={handleAlignment}
          aria-label="text alignment"
          sx={{ width: '100%', bgcolor: '#fff' }}
        >

          <ToggleButton value="all" aria-label="all" sx={toggleBtn} onClick={() => getCounselList(counselType, '')}>
            <DehazeIcon fontSize='small' />
            <Typography>전체</Typography>
          </ToggleButton>
          <ToggleButton value="active" aria-label="active" sx={toggleBtn} onClick={() => getCounselList(counselType, 'EXERCISE')}>
            <FitnessCenterIcon fontSize='small' />
            <Typography>운동</Typography>
          </ToggleButton>
          <ToggleButton value="health" aria-label="health" sx={toggleBtn} onClick={() => getCounselList(counselType, 'HEALTH')}>
            <HealthAndSafetyIcon fontSize='small' />
            <Typography>건강</Typography>
          </ToggleButton>
          <ToggleButton value="meal" aria-label="meal" sx={toggleBtn} onClick={() => getCounselList(counselType, 'DIET')}>
            <FlatwareIcon fontSize='small' />
            <Typography>식이</Typography>
          </ToggleButton>

        </ToggleButtonGroup>
      </Stack>

      <Box sx={{ mt: 4 }}>

        {counselList.length <= 0 ? (
          <Box sx={{textAlign:'center', mt:10}}>
            <SupportAgentIcon sx={{fontSize:50, color: '#999'}} />
            <Typography sx={{ fontSize: 16, color: '#777' }}>
              상담 내역이 없습니다.
            </Typography>
          </Box>
        ) : (
          <React.Fragment>
            {counselList && counselList.map((item, index) => (
              <React.Fragment key={index}>
                <Accordion sx={{ mb: 2, width: '100%' }}
                  key={index}
                  onChange={() => accordionClicked(index)}
                  expanded={expandedAccordions.includes(index)}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      width: '100%',
                      '& .MuiAccordionSummary-content ': { width: '100%', m: '0 !important' }
                    }}
                  >
                    <Stack direction={'column'} sx={{ width: '100%', p: 2, pl: 0, pr: 0, boxSizing: 'border-box' }}>

                      <Stack direction="row" >
                        {getCategoryChipComponent(item.category)}
                        {util.strNull(item.answerDate) < '1900-01-01' ? (
                          <Chip label="답변대기" color="warning" icon={<MoreHorizIcon />} size="small" sx={{ ml: 'auto' }} />
                        ) : (
                          <Chip label="답변완료" color="success" icon={<CheckIcon />} size="small" sx={{ ml: 'auto' }} />
                        )}
                      </Stack>

                      <Typography component='div' sx={{ mt: 2, mb: 1, fontWeight: 700, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>
                        {item.title}
                      </Typography>
                      <Typography component='div' sx={{ fontSize: 12, color: '#999' }}>{item.createDate.substring(0, 10)}</Typography>

                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails sx={{ pt: 0, }}>

                    {item.content.split('\n').map((item: any, lineIndex: number) => (
                      <Typography key={lineIndex} sx={{ fontSize: 14, color: '#777', }}>
                        {item}
                      </Typography>
                    ))}
                    {// 작성자가 동일하고, 답변대기 중인 경우에만 수정할 수 있도록 버튼 제공
                  util.strNull(item.answerDate) < '1900-01-01' && util.strNull(window.localStorage.userID) === item.memberId ? (
                    <Button sx={{display:'flex', ml:'auto', p: 0, }} onClick={() => navigate('/check/CreateCounsel', { state: { supportId: item.id } })}>
                     
                      <Chip variant="outlined" color="warning" icon={<BorderColorIcon sx={{  fontSize: 16,pl:1}}/>}  label="수정" sx={{  fontSize: 14,  fontWeight: 700,  }} />
                    </Button>
                  ) : (
                    null
                  )}
                  </AccordionDetails>

                  <AccordionDetails sx={{ p: 2, }}>
                    <Divider>
                      <Chip icon={<SupportAgentIcon />} label="답변" sx={{}} />
                    </Divider>
                    <Box sx={{ p: 1, pt: 2 }}>
                      {/*{item.answer.split('\n').map((item: any) => (*/}
                      {/*  <Typography sx={{ fontSize: 14, color: '#777', fontWeight: 700 }}>*/}
                      {/*    {item}*/}
                      {/*  </Typography>*/}
                      {/*))}*/}
                      {(item.answer ?? ' ').split('\n').map((line: string, index: number) => (
                          <Typography key={index} sx={{ fontSize: 14, color: '#777', fontWeight: 700 }}>
                            {line}
                          </Typography>
                      ))}
                    </Box>
                  </AccordionDetails>
                </Accordion>
                
              </React.Fragment>
            ))}
          </React.Fragment>
        )}

      </Box>

      <Box sx={{ position: 'fixed', bottom: 60, right: 10, '& > :not(style)': { m: 1, } }}>
        <Fab size="small" color="secondary" aria-label="Creat"
          onClick={() => {
            navigate('/check/CreateCounsel', { state: { supportId: 0 } });
          }}
        >
          <CreateIcon />
        </Fab>
      </Box>

      <Bottom />
    </Container>
  );
}



const toggleBtn = {
  p: 0,
  pt: 1,
  pb: 1,
  flex: '1 1 auto',
  '& .MuiSvgIcon-root': { pl: .3 },
  '& p': { fontSize: 14, p: 0, pl: 1 },
  '&.Mui-selected p': { fontWeight: 700 }

}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '50%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

export default Counsel;